var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c(
        "th",
        {
          staticClass: "py-4 text-sm relative pl-4",
          staticStyle: { width: "121px" },
          attrs: { scope: "col" },
        },
        [
          _vm._v(" Status"),
          _c("span", { staticClass: "right-border px-2 absolute right-2" }),
        ]
      ),
      _c(
        "th",
        {
          staticClass: "px-2 py-4 text-sm",
          staticStyle: { width: "100px" },
          attrs: { scope: "col" },
        },
        [_vm._v("Notes")]
      ),
      _c(
        "th",
        {
          staticClass: "py-4 text-sm relative",
          staticStyle: { width: "232px" },
          attrs: { scope: "col" },
        },
        [
          _vm._v(" Assignee "),
          _c("span", { staticClass: "right-border px-2 absolute right-2" }),
        ]
      ),
      _c(
        "th",
        {
          staticClass: "py-4 text-sm relative",
          staticStyle: { width: "160px" },
          attrs: { scope: "col" },
        },
        [
          _vm._v(" Job Title "),
          _c("span", { staticClass: "right-border px-2 absolute right-2" }),
        ]
      ),
      _c(
        "th",
        {
          staticClass: "py-4 text-sm relative",
          staticStyle: { width: "132px" },
          attrs: { scope: "col" },
        },
        [
          _vm._v(" Date & Visit Time "),
          _c("span", { staticClass: "right-border px-2 absolute right-2" }),
        ]
      ),
      _c(
        "th",
        {
          staticClass: "py-4 text-sm relative",
          staticStyle: { width: "113px" },
          attrs: { scope: "col" },
        },
        [
          _vm._v(" Activity "),
          _c("span", { staticClass: "right-border px-2 absolute right-2" }),
        ]
      ),
      _c(
        "th",
        {
          staticClass: "py-4 text-sm relative",
          staticStyle: { width: "160px" },
          attrs: { scope: "col" },
        },
        [
          _vm._v(" Location "),
          _c("span", { staticClass: "right-border px-2 absolute right-2" }),
        ]
      ),
      _c(
        "th",
        {
          staticClass: "py-4 text-sm relative",
          staticStyle: { width: "100px" },
          attrs: { scope: "col" },
        },
        [
          _vm._v(" Clock In "),
          _c("span", { staticClass: "right-border px-2 absolute right-2" }),
        ]
      ),
      _c(
        "th",
        {
          staticClass: "py-4 text-sm relative",
          staticStyle: { width: "100px" },
          attrs: { scope: "col" },
        },
        [
          _vm._v(" Clock Out "),
          _c("span", { staticClass: "right-border px-2 absolute right-2" }),
        ]
      ),
      _c(
        "th",
        {
          staticClass: "py-4 text-sm",
          staticStyle: { width: "160px,min-width: 80px" },
          attrs: { scope: "col" },
        },
        [_vm._v(" Tags "), _c("span", { staticClass: "px-2" })]
      ),
      _c("th", {
        staticClass: "px-2 py-4 text-sm",
        staticStyle: { width: "57px" },
        attrs: { scope: "col" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }